import React, { useState, useEffect } from "react";

import { Outlet, useNavigate, useParams, useLocation } from "react-router-dom";

import { getOrderHistory } from '../../services/getOrderHistory'

const Orders = () => {
    const navigate = useNavigate();

    const [search, setSearch] = useState("");
    const [productOrders, setProductOrders] = useState([]);

    useEffect(() => {
        getOrderHistoryData();
    }, []);

    const getOrderHistoryData = async () => {
        try {
            const response = await getOrderHistory();
            if (response?.status) {
                const result = response?.data?.data?.orders;
                // console.log("result:", result);
                // Extract and format product data
                const formattedData = result.flatMap(order => {
                    return JSON.parse(order.product_ids).map(product => ({
                        product_name: product.product_name,
                        product_weight: product.product_weight,
                        product_qty: product.product_qty,
                        product_image: product.product_image,
                        status: order.status, // Keeping order status if needed
                        orderId: `SL-000${order.order_id}`,
                    }));
                });

                setProductOrders(formattedData);
                // console.log("Formatted Products:", formattedData);
            } else {
                console.error("API response status is false:", response);
            }
        } catch (error) {
            console.error("Error in getOrderHistoryData:", error);
        }
    };

    const filteredOrders = productOrders.filter(product =>
        product.product_name.toLowerCase().includes(search.toLowerCase()) ||
        product.orderId.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div className="">
            <div className="flex justify-between items-center mb-4">
                <h1 className="text-lg font-bold"> Your Order History</h1>
                {/* <div className="col-span-12">
                    <button type="button"
                        onClick={() => navigate(-1)}
                        className="inline-flex items-center border border-indigo-300 px-2 py-1 rounded-md bg-[#AD826D] text-white hover:bg-white-50">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" stroke="currentColor" className="h-4 w-4">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16l-4-4m0 0l4-4m-4 4h18">
                            </path>
                        </svg>
                        <span className="ml-1 font-bold text-sm">Back</span>
                    </button>
                </div> */}
            </div>
            <div className="flex items-center  flex-col md:flex-row flex-wrap space-y-2 md:space-y-0 py-2 bg-white dark:bg-white-900 justify-center p-2">
                <label htmlFor="table-search" className="sr-only">
                    Search
                </label>
                <div className="relative">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none">
                        <svg
                            className="w-4 h-6 text-gray-500 dark:text-gray-400"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                        >
                            <path
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                            />
                        </svg>
                    </div>
                    <input
                        type="text"
                        id="table-search-users"
                        className="block p-2 pl-10 text-sm text-black border border-black rounded-lg w-50 bg-transparent focus:ring-black focus:border-black dark:text-black dark:focus:ring-white dark:focus:border-white"
                        placeholder="Search for users"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>
            </div>
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                <div className="relative w-full">
                    <div className="max-h-[25rem] overflow-y-auto">
                        <table className="w-full text-sm text-left bg-white dark:text-black">
                            <thead className="sticky top-0 z-10 text-xs text-black-700 uppercase bg-white dark:bg-black-700 dark:text-black">
                                <tr>
                                    <th scope="col" className="px-4 py-2">OrderId</th>
                                    <th scope="col" className="px-4 py-2">Name</th>
                                    <th scope="col" className="px-4 py-2">Weight</th>
                                    <th scope="col" className="px-4 py-2">Quantity</th>
                                    <th scope="col" className="px-4 py-2">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredOrders.length > 0 ? (
                                    filteredOrders.map((product, index) => (
                                        <tr
                                            key={index}
                                            className="bg-white border-b dark:bg-black-800 dark:border-black-700 border-black-200 hover:bg-black-50 dark:hover:bg-black-600"
                                        >
                                            <td className="px-4 py-2">{product.orderId}</td>
                                            <th scope="row" className="flex justi items-center px-4 py-2 text-white-900 dark:text-black">
                                                <img className="w-10 h-10 rounded-full" src={product.product_image} alt={product.product_name} />
                                                <div className="pl-3">
                                                    <div className="text-base font-semibold">{product.product_name}</div>
                                                </div>
                                            </th>
                                            {/* <td className="px-4 py-2">{product.product_weight}</td> */}
                                            <td className="px-4 py-2">{parseFloat(product.product_weight) * (product.product_qty || 0)} gm</td>
                                            <td className="px-4 py-2">{product.product_qty}</td>
                                            <td className="px-4 py-2">{product.status}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5" className="text-center py-4 text-black-500">No products found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Orders;
